module.exports = __webpack_public_path__ + "static/media/banner-site.b7ce20f0.jpg";